import { PROVIDER_TEXTS as TEXTS } from '../constants/providersConstants';

const CUIT_DIGITS = 11;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Valida el formulario de proveedor antes de enviarlo.
 * @param {Object} form Estado del formulario.
 * @returns {Object} Errores por campo (vacío si es válido).
 */
export const validateProviderForm = (form) => {
  const errors = {};
  if (!form.legal_business_name?.trim()) errors.legal_business_name = TEXTS.required;
  if (String(form.cuit || '').replace(/\D/g, '').length !== CUIT_DIGITS) {
    errors.cuit = TEXTS.invalidCuit;
  }
  if (form.email && !EMAIL_PATTERN.test(form.email.trim())) errors.email = TEXTS.invalidEmail;
  return errors;
};
